import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../PageTemplate/ListFormTemplate";
import { config } from "../../utils/config";
import { fetchDataAndMapToField } from "../../utils/helperFuctions";
import useUsersLogic from "./useUsersLogic";

const columns = [
  {
    field: "concat",
    label: "Name",
    allowSorting: true,
    concatBy: " ",
    concat: [{ field: "first_name" }, { field: "last_name" }],
  },
  { field: "email", label: "Email", allowSorting: true },
  {
    field: "role",
    label: "Role",
    allowSorting: true,
    subvalue: "name",
    showInFilter: true,
  },
];

const UsersPage = () => {
  const { addRoles, apiRoute, deleteRoles, editRoles, initFields, tabsData } =
    useUsersLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async () => {
    try {
      const temp = [...initFields];
      await Promise.all([
        fetchDataAndMapToField(config, "roles", "role", temp),
      ]);
      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to Users" />
      </Helmet>
      <ListFormTemplate
        tableNameInDb="directus_users"
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        tabsData={tabsData}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        enhancedTable={true}
      />
    </div>
  );
};

export default UsersPage;
